module.exports = __webpack_public_path__ + "img/25_Papilla.b69d6ca3.png";